import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import StepThreeForm from 'appSrc/components/Shards/VideoImageSelector/form';
import style from '../styles/style.module.css';

class StepThree extends PureComponent {
    constructor(props) {
        super( props );
    }
    onSubmit = ( data ) => {
        this.props.onSubmit( {
            coverImage: data.selectedImage,
            youtube: data.youtubeId,
        } );
    }
    render() {
        return (
            <div className={ `${ style.stepThree } ${ style.listCreationStep }` }>
                <div className={ style.titleBar }>
                    <h2>Add a Photo or Video</h2>
                    <p>Add some media that represents this list. You can add photo or video.</p>
                </div>
                <div className={ style.stepContent }>
                    <StepThreeForm onSubmit={ this.onSubmit } />
                </div>
            </div>
        );
    }
}
StepThree.defaultProps = {
    onSubmit: ()=>{},
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        ownLists: state.self.lists,
    };
};

export default connect( mapStateToProps )( StepThree );
